import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { paymentsApi, subscribe } from '../utils/paymentsStore';
import { PageHeader, Panel, Empty, Skeleton, Icon, useToast, fmtMoney } from '../components/ui';

export default function PayersPage() {
  const [payers, setPayers] = useState(null);
  const [claims, setClaims] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showToast, toastNode] = useToast();

  useEffect(() => {
    const load = () => Promise.all([paymentsApi.listPayers(), paymentsApi.listClaims()]).then(([p, c]) => { setPayers(p); setClaims(c); });
    load(); return subscribe(load);
  }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!editing.name.trim()) return;
    await paymentsApi.upsertPayer({ ...editing, aliases: String(editing.aliasText || '').split(',').map(s => s.trim()).filter(Boolean) });
    showToast('Payer saved'); setEditing(null);
  };
  const toggle = async (p) => { await paymentsApi.upsertPayer({ ...p, active: !p.active }); };
  const stats = (p) => { const rows = claims.filter(c => c.payerId === p.payerId); return { count: rows.length, billed: rows.reduce((s, c) => s + c.amountBilledCents, 0), paid: rows.reduce((s, c) => s + c.amountPaidCents, 0) }; };

  return (
    <main className="main-content ops-main">
      <div className="ops-page">
        <PageHeader title="Payers" subtitle="Insurance companies used by authorizations and claims. Aliases help the importer match spreadsheet spellings."
          meta={<Link to="/settings" className="ops-link">Settings</Link>}
          actions={<button type="button" className="ops-btn ops-btn--primary" onClick={() => setEditing({ name: '', shortName: '', aliasText: '', active: true })}><Icon name="plus" /> Add payer</button>} />
        <Panel flush>
          {!payers ? <Skeleton /> : payers.length === 0 ? <Empty title="No payers">Add the insurance companies you bill.</Empty> : (
            <div className="ops-table-wrap"><table className="ops-table">
              <thead><tr><th>Payer</th><th>Short name</th><th>Aliases</th><th className="num">Claims</th><th className="num">Billed</th><th className="num">Paid</th><th>Active</th><th></th></tr></thead>
              <tbody>{payers.map(p => { const s = stats(p); return (
                <tr key={p.payerId}>
                  <td className="ops-cell-main">{p.name}</td><td>{p.shortName}</td>
                  <td className="ops-cell-sub">{(p.aliases || []).join(', ')}</td>
                  <td className="num">{s.count}</td><td className="num">{fmtMoney(s.billed)}</td><td className="num">{fmtMoney(s.paid)}</td>
                  <td><label className="ops-check"><input type="checkbox" checked={p.active !== false} onChange={() => toggle(p)} /> {p.active !== false ? 'Yes' : 'No'}</label></td>
                  <td className="num"><button type="button" className="ops-btn ops-btn--sm" onClick={() => setEditing({ ...p, aliasText: (p.aliases || []).join(', ') })}>Edit</button></td>
                </tr>); })}</tbody>
            </table></div>
          )}
        </Panel>
        {editing && (
          <>
            <div className="ops-drawer__backdrop" onClick={() => setEditing(null)} />
            <aside className="ops-drawer ops-drawer--narrow" role="dialog" aria-modal="true" aria-label="Payer">
              <form onSubmit={save} style={{ display: 'contents' }}>
                <div className="ops-drawer__head"><h2>{editing.payerId ? 'Edit payer' : 'Add payer'}</h2><button type="button" className="ops-close" onClick={() => setEditing(null)} aria-label="Close"><Icon name="x" /></button></div>
                <div className="ops-drawer__body">
                  <label className="ops-field">Name<input className="ops-input" value={editing.name} onChange={e => setEditing(x => ({ ...x, name: e.target.value }))} required autoFocus /></label>
                  <label className="ops-field">Short name<input className="ops-input" value={editing.shortName || ''} onChange={e => setEditing(x => ({ ...x, shortName: e.target.value }))} /></label>
                  <label className="ops-field">Aliases (comma separated)<textarea className="ops-input" rows={3} value={editing.aliasText} onChange={e => setEditing(x => ({ ...x, aliasText: e.target.value }))} placeholder="Other spellings seen in remittances or spreadsheets" /></label>
                  <label className="ops-check"><input type="checkbox" checked={editing.active !== false} onChange={e => setEditing(x => ({ ...x, active: e.target.checked }))} /> Active (shown in claim and authorization forms)</label>
                </div>
                <div className="ops-drawer__foot"><span /><span className="ops-actions"><button type="button" className="ops-btn" onClick={() => setEditing(null)}>Cancel</button><button type="submit" className="ops-btn ops-btn--primary">Save</button></span></div>
              </form>
            </aside>
          </>
        )}
      </div>
      {toastNode}
    </main>
  );
}
